import { Component, OnInit, Input } from '@angular/core';
import { RouterModule, ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent implements OnInit {
    @Input() heading: string;
    @Input() icon: string;
    constructor(private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService) {

        if (this.authenticationService.needPasswordReset()) {
            if (this.router.url !== '/account/changepassword')
                this.router.navigate(['/account/changepassword']);
        } 
    }

    ngOnInit() {
        
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/modules/page-header/page-header.component.ts